// pico components
import { picoapp } from 'picoapp'
import announcementBar from '../components/announcement-bar'
import collection from '../components/collection'
import collectionLink from '../components/collection-link'
import collectionFilterBy from '../components/collection-filter-by'
import collectionSortBy from '../components/collection-sort-by'
import faqAnchor from '../components/faq-anchor'
import flavorSelector from '../components/flavor-selector'
import giftNote from '../components/gift-note'
import newsletter from '../components/newsletter'
import product from '../components/product'
import purchaseTypeSelector from '../components/purchase-type-selector'
import productDetailsTab from '../components/product-details-tab'
import productModal from '../components/product-modal'
import quantitySelector from '../components/quantity-selector'
import scrollTrackSlider from '../components/scroll-track-slider'
import recommendedProducts from '../components/recommended-products'
import registerNewsletter from '../components/register-newsletter'
import sizeOptionSelector from '../components/size-option-selector'
import sortByLink from '../components/sort-by-link'
import infiniteScrollGrid from '../components/infinite-scroll-grid'
import ugcSlider from '../components/ugcSlider'
import yotpoStarRating from '../components/yotpo-star-rating'
import yotpoMainReviews from '../components/yotpo-main-reviews'
import touchElement from '../components/touchElement'

const components = {
  announcementBar,
  collection,
  collectionLink,
  collectionFilterBy,
  collectionSortBy,
  faqAnchor,
  flavorSelector,
  giftNote,
  infiniteScrollGrid,
  quantitySelector,
  recommendedProducts,
  newsletter,
  product,
  productDetailsTab,
  productModal,
  purchaseTypeSelector,
  registerNewsletter,
  scrollTrackSlider,
  sizeOptionSelector,
  sortByLink,
  touchElement,
  ugcSlider,
  yotpoStarRating,
  yotpoMainReviews,
}

export default picoapp(components)
